var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 3.99967V3.46634C9.66667 2.7196 9.66667 2.34624 9.52134 2.06102C9.39351 1.81014 9.18954 1.60616 8.93865 1.47833C8.65344 1.33301 8.28007 1.33301 7.53333 1.33301H6.46667C5.71993 1.33301 5.34656 1.33301 5.06135 1.47833C4.81046 1.60616 4.60649 1.81014 4.47866 2.06102C4.33333 2.34624 4.33333 2.7196 4.33333 3.46634V3.99967M5.66667 7.66634V10.9997M8.33333 7.66634V10.9997M1 3.99967H13M11.6667 3.99967V11.4663C11.6667 12.5864 11.6667 13.1465 11.4487 13.5743C11.2569 13.9506 10.951 14.2566 10.5746 14.4484C10.1468 14.6663 9.58677 14.6663 8.46667 14.6663H5.53333C4.41323 14.6663 3.85318 14.6663 3.42535 14.4484C3.04903 14.2566 2.74307 13.9506 2.55132 13.5743C2.33333 13.1465 2.33333 12.5864 2.33333 11.4663V3.99967",
    stroke: "#F04438",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.2b4e95f3f8b35ba10c5e4ef85032d6d6.svg";
export { ForwardRef as ReactComponent };